import React, { useEffect, useContext, useState } from "react";
import "./companyProfileRegistration.css";
import strings from "../../utils/property-file/companyProfileRegistration.json";
import Ripple from "../button/ripple";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import constants from "../../utils/constants";
import { useForm, Controller } from "react-hook-form";
import Autocomplete from "react-google-autocomplete";
import { FormContext } from "../formContext";
import bytesToMB from "../../utils/commonFunction/bytesToMb";
import  {CompanyLogoContext} from "../companyLogoContext";

export default function CompanyProfileRegistration() {

  useEffect(() => {
    if (!location.state) {
      nav(constants.navigationLink.loginLink);
    }
  }, []);

  const nav = useNavigate();
  const location = useLocation();
  const { formData, setFormData, address, setAddress } = useContext(FormContext);
  const [logoUploadError , setLogoUploadError] = useState(strings.disableLabel);
  const { companyLogo, setCompanyLogo } = useContext(CompanyLogoContext);

  function companyLogoUpload(event)
  {
    const selectFile=event.target.files[0];
    const fileSize=selectFile.size;
    const fileSizeMb=bytesToMB(fileSize);

    if(selectFile.type===strings.pngLabel || selectFile.type===strings.jpegLabel || selectFile.type===strings.jpgLabel &&  fileSizeMb<=10)
    {
      setLogoUploadError(strings.disableLabel);
      setCompanyLogo(selectFile);
    }
    else
    {
      setCompanyLogo(null);
      setLogoUploadError(strings.activeLabel);
    }
  }

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const handleFormChange = (data) => {
    setFormData((prevFormData) => ({ ...prevFormData, data }));
  };

  const createCompanyProfile = (data) => {
    if (address == "") {
      toast.error(strings.companyAddressReq, { toastId: "error7" });
    } else {
      nav(constants.navigationLink.adminProfileLink, { state: true });
    }
    handleFormChange(data);
  };

  return (
    <React.Fragment>
      <div className="parent-admin-container mx-auto">
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <div className="child-admin-container mx-auto">
          <label htmlFor="company-logo">
            <div className="company-logo-upload-container">
            <div className="company-logo-upload-sub-container">
              {companyLogo != null ? (
                <img src={URL.createObjectURL(companyLogo)} className="uploaded-logo" />
              ) : (
                <i className="ri-building-4-line" id="building-logo"></i>
              )}

              <i className="ri-camera-line" id="camera-logo"></i>
              <input
                type="file"
                id="company-logo"
                className="d-none "
                accept="image/png , image/jpeg, image/jpg"
                onChange={(event) => {
                  companyLogoUpload(event);
                }}
              />
            
            </div>
            <div className={logoUploadError}><strong className="mx-1">&#9432;</strong> {strings.logoUploadError}</div>
            </div> 
          </label>
          <div className="company-page-heading">
            <h4 className="mt-3">{strings.companyProfile}</h4>
            <p>
              {strings.companyDesc}
              <strong> {strings.step1}</strong>
            </p>
          </div>
          <div className="grand-child-form">
            <form onSubmit={handleSubmit(createCompanyProfile)}>
              <div className="form-floating">
                <input
                  {...register("name", {
                    required: strings.companyNameValidation,
                    minLength: {
                      value: 2,
                      message: strings.minCharError,
                    },
                    maxLength: 50,
                    pattern: {
                      value: constants.inputPattern.patternWithoutSpaceSecond,
                      message: strings.errorLabel,
                    },
                  })}
                  type="text"
                  name="name"
                  defaultValue={formData ? formData.data.name : ""}
                  className={
                    errors.name
                      ? "form-control validateEmail email-input input-text-alert pb-0"
                      : "form-control validateEmail email-input pb-0"
                  }
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.companyUniqueName}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.name && (
                      <span>
                        <strong className="me-1">&#9432;</strong>
                        {errors.name.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="form-floating">
                <input
                  {...register("email", {
                    required: strings.emailValidation,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: strings.emailValidate,
                    },
                  })}
                  type="email"
                  className={
                    errors.email
                      ? "form-control validateEmail email-input input-text-alert pb-0"
                      : "form-control validateEmail email-input pb-0"
                  }
                  name="email"
                  defaultValue={formData ? formData.data.email : ""}
                  placeholder=" "
                  autoComplete="off"
                />
                <label
                  htmlFor="floating-input"
                  className="text-light input-place"
                >
                  {strings.companyEmailAddress}
                </label>
                <div className="form-validation">
                  <small>
                    {errors.email && (
                      <span>
                        <strong className="me-1">&#9432;</strong> {errors.email.message}
                      </span>
                    )}
                  </small>
                </div>
              </div>
              <div className="address-field">
                <label
                  htmlFor="floating-input"
                  className="text-light label-text"
                >
                  {strings.companyAddress}
                </label>
                <Controller
                  name="companyAddress"
                  rules={{ required: true }}
                  control={control}
                  defaultValue={address ? address : ""}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={
                        errors.companyAddress
                          ? "company-address-input-field error"
                          : "company-address-input-field"
                      }
                      placeholder={strings.companyAddressHeading}
                      apiKey={constants.apiName.apiKey}
                      value={address}
                      options={{
                        types: ["geocode", "establishment"],
                      }}
                      onChange={(e) => {
                        setAddress(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      onPlaceSelected={(place) => {
                        field.onChange(place.formatted_address);
                        setAddress(place.formatted_address);
                      }}
                    />
                  )}
                />
                <div
                  className={
                    errors.companyAddress ? "form-validation" : "display-none"
                  }
                >
                  {errors.companyAddress && (
                    <span>
                      <strong className="me-1">&#9432;</strong>
                      {strings.companyAddressValidation}
                    </span>
                  )}
                </div>
              </div>
              <div className="mt-1 mb-1 text-light">
                <label className="mt-1 select-box-label">
                  {strings.companySizeHeading}
                </label>
                <select
                  {...register("companySize", { required: true })}
                  className={
                    errors.companySize
                      ? "bg-transparent error"
                      : "bg-transparent select-dropdown"
                  }
                  name="companySize"
                  defaultValue={formData ? formData.data.companySize : ""}
                >
                  <option id="dropdown-label-title" value="" hidden selected>
                    <p>{strings.companySizeHeading}</p>
                  </option>
                  {strings.companySizeList.map((item ,index) => {
                    return (
                      <option id="dropdown-label" key={index} value={item}>
                        <p>{item}</p>
                      </option>
                    );
                  })}
                </select>
                <div className="form-validation">
                  <small>
                    {errors.companySize && (
                      <span>
                      
                        <strong className="me-1">&#9432;</strong> {strings.companySizeValidation}
                      </span>
                    )}
                  </small>
                </div>
              </div>

              <div className="mt-1 mb-1 text-light">
                <label className="mt-1 select-box-label">
                  {strings.companyType}
                </label>
                <select
                  {...register("companyType", { required: true })}
                  className={
                    errors.companyType
                      ? "bg-transparent error"
                      : "bg-transparent select-dropdown"
                  }
                  name="companyType"
                  defaultValue={formData ? formData.data.companyType : ""}
                >
                  <option id="dropdown-label-title" value="" hidden selected>
                    <p>{strings.companyTypeHeading}</p>
                  </option>
                  {strings.companyTypeList.map((item ,index) => {
                    return (
                      <option id="dropdown-label" key={index} value={item}>
                        <p>{item}</p>
                      </option>
                    );
                  })}
                </select>
                <div className={"form-validation"}>
                  <small>
                    {errors.companyType && (
                      <span>
                       
                        <strong className="me-1">&#9432;</strong> {strings.companyTypeValidation}
                      </span>
                    )}
                  </small>
                </div>
              </div>

              <button type="submit" className="btn btn-primary next-btn">
                <Ripple duration={1000} />
                {strings.loginBtn}
              </button>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
